module.exports = __webpack_public_path__ + "img/location_setting_android_7.5d9e920d.png";